import {
  format,
  getTime,
  formatDistanceToNow,
  differenceInDays,
  differenceInHours,
  isSameDay,
  parse,
  isBefore,
  isEqual,
  addDays,
} from "date-fns";
import moment from "moment";

// ----------------------------------------------------------------------

export function formatTo24h(timeStr) {
  if (!timeStr) return "";
  const s = String(timeStr).trim();
  if (s.includes("-") || s.includes("T")) {
    const m = moment(s);
    if (m.isValid()) return m.format("HH:mm");
  }
  const m = moment(
    s,
    ["HH:mm:ss", "HH:mm", "hh:mma", "hh:mm a", "h:mma", "h:mm a", "hh:mmA", "h:mmA"],
    false,
  );
  if (m.isValid()) {
    return m.format("HH:mm");
  }
  const match = s.match(/(\d{1,2}):(\d{2})/);
  if (match) {
    const h = match[1].padStart(2, "0");
    const min = match[2];
    return `${h}:${min}`;
  }
  return s.toLowerCase().replace(/\s/g, "");
}

export function fDate(date, hideYear) {
  return format(
    typeof date === "string" ? new Date(date.replace(/-/g, "/")) : date,
    hideYear ? "MMM do" : "dd MMM yyyy",
  );
}

export function formatDate(date, formatStr = "yyyy-MM-dd") {
  return format(
    typeof date === "String" ? parse(date, "yyyy-MM-dd", new Date()) : date,
    formatStr,
  );
}

export function formatDateObject(date, formatStr = "yyyy-MM-dd HH:mm:ss") {
  return parse(date, formatStr, new Date());
}

export function fDateTime(date, formatTime = "dd MMM yyyy hh:mm aa") {
  return format(new Date(date.replace(/-/g, "/")), formatTime);
}
export function fTime(date) {
  return format(new Date(date.replace(/-/g, "/")), "hh:mm aa");
}

export function fTimestamp(date) {
  return getTime(new Date(date.replace(/-/g, "/")));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date.replace(/-/g, "/")), "dd/MM/yyyy hh:mm p");
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date.replace(/-/g, "/")), {
    addSuffix: true,
    includeSeconds: true,
  });
}

export function datesBetween(startDate, endDate) {
  const dates = [];
  let currentDate = startDate;
  // Loop while the current date is before or equal to the end date
  while (isBefore(currentDate, endDate) || isEqual(currentDate, endDate)) {
    dates.push(formatDate(currentDate));
    currentDate = addDays(currentDate, 1); // Add one day to the current date
  }

  return dates;
}

export function fRelative(date) {
  if (isSameDay(date, new Date())) {
    return "Today";
  }
  if (fInterval(new Date(), date, 0) === -1) {
    return "Yesterday";
  }

  // if (fInterval(new Date(), date, 0) === 1) {
  //   return "Tomorrow";
  // }
  return ` on ${formatDate(date, "MMM dd")}`;
}

export function fInterval(startDate, endDate, isAbsolute = 1) {
  const value = differenceInDays(
    endDate
      ? (typeof endDate === "object" && endDate) ||
      new Date(endDate.replace(/-/g, "/"))
      : new Date(),
    (typeof startDate === "object" && startDate) ||
    new Date(startDate.replace(/-/g, "/")),
  );
  return isAbsolute === 1 ? Math.abs(value) : value;
}
export function fTimeInterval(startDate, endDate) {
  return differenceInHours(
    typeof endDate === "object"
      ? endDate
      : new Date(endDate.replace(/-/g, "/")),
    typeof startDate === "object"
      ? startDate
      : new Date(startDate.replace(/-/g, "/")),
  );
}
export function fDateRange(dateStart, dateEnd) {
  const sDate = new Date(dateStart.replace(/-/g, "/"));
  const eDate = new Date(dateEnd.replace(/-/g, "/"));
  if (sDate.getFullYear() === eDate.getFullYear()) {
    if (sDate.getMonth() === eDate.getMonth()) {
      if (sDate.getDate() === eDate.getDate()) {
        return format(sDate, "dd MMM yyyy");
      }
      return `${format(sDate, "dd")} - ${format(eDate, "dd")}, ${format(
        sDate,
        "MMM yyyy",
      )}`;
    }
    return `${format(sDate, "dd MMM")} - ${format(eDate, "dd MMM")}, ${format(
      sDate,
      "yyyy",
    )}`;
  }
  return `${format(sDate, "dd MMM yyyy")} - ${format(eDate, "dd MMM yyyy")}`;
}
